export default __webpack_public_path__ + "static/media/kitchen-pack-10.483f0550.png";